// extracted by mini-css-extract-plugin
export default {"container":"DraggableElement_container__2N-kT"};